import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import './styles/index.css'
import axios from 'axios'
import Router from 'vue-router'
import store from './store'
import _ from 'lodash'
Vue.prototype._ = _
Vue.config.productionTip = false

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(ElementUI)
// 所有组件都是vue实例
// 我们可以把一些需要在组件中频繁使用的成员放到vue.prototype 中
Vue.prototype.$http = axios
// 配置axios的基础路径
axios.defaults.baseURL = 'http://localhost:8081/background'
// axios.defaults.baseURL = 'http://192.168.1.8:8080/background_war'
// axios.defaults.baseURL = 'http://39.105.130.116:8888/background'
// axios.defaults.baseURL = 'http://192.168.1.8:8080/background_war'
//axios.defaults.baseURL = 'http://39.105.130.116:8080/background'
// axios.defaults.baseURL = 'http://39.105.130.116:8888/background'
const rootObj=new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default rootObj